//
// Copyright 2021 Emerald Associates, Inc.  All Rights Reserved.
//
// Use of this file other than by Emerald Associates, Inc. is forbidden
// unless otherwise authorized by a separate written license agreement.
//
// $Id$
//
import React from "react";
import UploadIcon from "@material-ui/icons/Publish";

import UploadFileWithConfigurationButton from "src/components/loader/buttons/UploadFileWithConfigurationButton";

const UploadButton = (props) => {
  return (
    <UploadFileWithConfigurationButton
      label="Upload"
      url="loader/uploadExcel"
      icon={<UploadIcon />}
      {...props}
    />
  );
};
export default UploadButton;
